<template>
	<link-input class="link-object-input"
				:suffix-icon="suffixIcon"
				input-readonly
				:value="(!!row&&!!showKey)?row[showKey]:null"

				:type="type"
				:color="color"
				:size="size"
				:shape="shape"
				:dashed="dashed"
				:long="long"
				:prefixIcon="prefixIcon"
				:placeholder="placeholder"
				:disabled="lv_disabled"
				:width="width"
				:clear-on-click-delete-icon="false"
				:hide-clear-icon="hideClearIcon"
				:required="required"
				:validate-on-init="validateOnInit"
				:rules="rules"
				@click-suffix-icon="!lv_disabled&&!lv_readonly && handleClickSuffixIcon()"
				@click="handleClick"/>
</template>

<script>
  import {EditMixin} from "../mixins";
  import deepmerge from "deepmerge";

  export default {
    name: "link-mvg-input",
    mixins: [EditMixin],
    props: {
      option: {required: true,},
      mvgParentIdKey: {type: String, default: 'id'},

      row: {required: true, type: Object},
      map: {require: true, type: Object},
      showKey: {required: true, type: String},

      beforeSelect: {type: Function},
      afterSelect: {type: Function},

      type: {type: String, default: 'line',},
      color: {type: String, default: 'info',},
      size: {type: String, default: 'default',},
      shape: {type: String, default: 'none',},
      dashed: {type: Boolean,},
      long: {type: Boolean,},
      prefixIcon: {type: String},
      suffixIcon: {type: String, default: 'link-icon-mvg'},
      placeholder: {type: String, default: () => LinkVue.$t('LinkAutoTable.search')},
      regexp: {type: RegExp},
      width: {},
      hideClearIcon: {type: Boolean},
      required: {type: Boolean},
      rules: {type: Array | String},
      validateOnInit: {type: Boolean,},
    },
    computed: {
      // lnk-mvg的map与link-mvg的由于一些原因，
      // key-val 刚好反过来了，这里需要处理一下
      lnkMap() {
        const obj = {};
        for (const key in this.map) {
          obj[this.map[key]] = key;
        }
        return obj;
      }
    },
    data() {
      return {
        oldChange: null,
      }
    },
    created() {
      this.option = deepmerge({}, this.option)
      this.oldChange = this.option.change
      this.option.change = this.handleChange
    },
    methods: {
      async handleClick() {
        !!this.beforeSelect && (await this.beforeSelect({row: this.row, option: this.option}))
        this.option.mvgParentId = this.row[this.mvgParentIdKey]
        this.$mvg.pick({
          ...this.option,
          pickMap: this.lnkMap,
          pickObject: this.row,
          disabled: this.lv_disabled || this.lv_readonly}, this);
      },
      async handleChange({changeDefaultFlag, changeList, defaultItem, deleteAllFlag, deleteItems, insertItems}) {
        this.$emit('change', {changeDefaultFlag, changeList, defaultItem, deleteAllFlag, deleteItems, insertItems})
        Object.keys(this.map).forEach(key => this.$set(this.row, key, defaultItem[this.map[key]]))
        !!this.afterSelect && (await this.afterSelect({row: this.row, option: this.option}))
        if (!!this.oldChange) {
          this.oldChange({changeDefaultFlag, changeList, defaultItem, deleteAllFlag, deleteItems, insertItems})
        }
      },
      async handleClickSuffixIcon() {
        !!this.beforeSelect && (await this.beforeSelect({row: this.row, option: this.option}))
        this.$emit('confirm', null)
        Object.keys(this.map).forEach(key => this.$set(this.row, key, null))
        !!this.afterSelect && (await this.afterSelect({row: this.row, option: this.option}))
      },
    }
  }
</script>

<style lang="scss">

</style>
